import type { MetaobjectBadge, ProductForBadge, BadgeResult, BadgeRule } from "~/lib/badges/types";
import { dateValidityRule } from "~/lib/badges/rules/date-validity";
import { exclusionTagsRule } from "~/lib/badges/rules/exclusion-tags";
import { collectionsRule } from "~/lib/badges/rules/collections";
import { stockStatusRule } from "~/lib/badges/rules/stock-status";
import { tagsRule } from "~/lib/badges/rules/tags";
import { discountRule } from "~/lib/badges/rules/discount";
import { mapStyleToColor, mapIconToBadgeIcon } from "~/lib/badges/style-map";
import { formatSaveBadgeText } from "~/lib/money";

const rules: BadgeRule[] = [
  dateValidityRule,
  exclusionTagsRule,
  collectionsRule,
  stockStatusRule,
  tagsRule,
  discountRule,
];

export function evaluateBadge(
  product: ProductForBadge,
  definitions: MetaobjectBadge[],
): BadgeResult | null {
  if (!definitions.length) return null;

  const applicable = definitions.filter((badge) =>
    rules.every((rule) => rule.evaluate(product, badge)),
  );

  if (!applicable.length) return null;

  // Highest priority wins; first in array wins on tie
  const winner = applicable.reduce((best, curr) => (curr.priority > best.priority ? curr : best));

  const label =
    winner.type.toLowerCase() === "discount"
      ? (formatSaveBadgeText(
          product.price,
          product.compareAtPrice,
          product.hasPriceRange ? "up to" : "",
        ) ?? winner.label)
      : winner.label;

  return {
    label,
    type: winner.type,
    color: mapStyleToColor(winner.style),
    icon: mapIconToBadgeIcon(winner.icon),
    size: "sm",
  };
}
